
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_ggkkn_63l4s_1",
  "navigation": "awsui_navigation_ggkkn_63l4s_5",
  "navigation-toggle": "awsui_navigation-toggle_ggkkn_63l4s_9",
  "navigation-close": "awsui_navigation-close_ggkkn_63l4s_13",
  "content": "awsui_content_ggkkn_63l4s_17",
  "notifications": "awsui_notifications_ggkkn_63l4s_21",
  "breadcrumbs": "awsui_breadcrumbs_ggkkn_63l4s_25",
  "tools": "awsui_tools_ggkkn_63l4s_29",
  "tools-close": "awsui_tools-close_ggkkn_63l4s_33",
  "tools-toggle": "awsui_tools-toggle_ggkkn_63l4s_37",
  "drawer-closed": "awsui_drawer-closed_ggkkn_63l4s_41",
  "mobile-bar": "awsui_mobile-bar_ggkkn_63l4s_45"
};
  